<div class="heading-tab">
  <h3 id="mainHeadingCoverage" class="heading"><i nz-icon nzType="file-protect" theme="outline"></i> Coverage Specific Decision For Insured Members
  </h3>
</div>


<nz-tabset style="height:auto" [nzTabPosition]="'left'">
  <nz-tab [nzTitle]="titleTmplInsuredDecision" *ngFor="let insuredObj of tempInsuredList;let i = index">
    <ng-template #titleTmplInsuredDecision>
      <strong class="d-b">Insured {{i + 1}}: {{insuredObj | MMSClientData: 'fullName'}}</strong>
      <p *ngIf="!insuredObj.policyOrCaseClient['uwDecisionCd']"
        [class.col-red]="!insuredObj.policyOrCaseClient['uwDecisionCd']" class="m-b-5">
        <i nz-icon nzType="close-circle" nzTheme="outline" class="m-r-5"></i>
        Decision Pending
      </p>
      <p *ngIf="insuredObj.policyOrCaseClient['uwDecisionCd']"
        [class.col-green]="insuredObj.policyOrCaseClient['uwDecisionCd']" class="m-b-5">
        <i nz-icon nzType="check-circle" nzTheme="outline"></i>
        Decision Given
      </p>
    </ng-template>

    <div>
      <h3 class="heading">Decision for Insured</h3>
      <div class="tab-grid m-t-20">
        <nz-form-item id='decisionFieldId' >
          <nz-form-label [nzSpan]="24">Decision</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch nzAllowClear style="width: 100%"
              [(ngModel)]="insuredObj.policyOrCaseClient['uwDecisionCd']"
              (ngModelChange)="setCoverageDecision(insuredObj,insuredObj.policyOrCaseClient['uwDecisionCd'])">
              <nz-option
                *ngFor="let item of (lookup$['manualUwDecisionCd'] | async) as decisionCd; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item id='reasonFieldId' *ngIf="insuredObj.policyOrCaseClient['uwDecisionCd'] === 'REJECT'">
          <nz-form-label [nzSpan]="24">Reason</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch nzAllowClear style="width: 100%"
              [(ngModel)]="insuredObj.policyOrCaseClient['reasonCd']">
              <nz-option
                *ngFor="let item of (lookup$.ReasonForRejectedDecision | async) as reasonLookupCd; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div>
        <nz-form-item id="remarksFieldId" >
          <nz-form-label [nzSpan]="24">Remarks</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <textarea id="remarksTextarea" rows="4" maxlength="2000" style="width:100%;" nz-input
              placeholder="{{'Enter your remarks'| translate}}..."
              [(ngModel)]="insuredObj.policyOrCaseClient['uwDecisionValue']"></textarea>
            <p style="font-size: xx-small;">
              {{insuredObj.policyOrCaseClient['uwDecisionValue']? insuredObj.policyOrCaseClient['uwDecisionValue'].length: 0}}/2000
              Characters</p>
          </nz-form-control>
        </nz-form-item>
      </div>

    </div>

    <!-- FORM -->
    <ng-container *ngIf="!(insuredObj['uwDecisionCd']) && showCoverageTable; else showNoInsuredSpecificCoverageMsg">

      <h3 class="heading">Coverage wise Decision</h3>
      <!-- <app-claims-benefit></app-claims-benefit> -->
      <div class="list-benefits">

        <nz-table class="valign-top" #coverageTable [nzData]="[1]" [nzShowPagination]="false">
          <thead>
            <tr>
              <th style="width=200px">Coverage Name</th>
              <th style="width=120px">{{appMetadataHandler.SI_LABEL}}</th>
              <th style="width=120px">Premium</th>
              <th style="width:290px">Decision</th>
              <th style="width=120px" *ngIf="loadingPercent && loadingPercent.length && !revisedSumAssured">Loading</th>
              <!-- <th>Deductible Remarks</th> -->
              <th>Actions</th>
            </tr>
          </thead>
          <tbody class="valign-top">         

            <ng-container *ngFor="let coverage of coverageList; let i = index">
              <!-- <span>coverage:- {{coverage | json}}</span> -->
              <!-- <span>coverageList: - {{coverageList | json}}</span>
              <span>cov: - {{coverage[UICoverageInsuredNodeName][insuredObj.guid]}}</span>
             <span>suminsured: - {{coverage.sumInsuredAmt}}</span> -->
             <!-- <span>Insured Object {{ insuredObj | json }}</span> -->
             <!-- <span>cov: - {{coverage[UICoverageInsuredNodeName] | json}}</span> -->

              <tr *ngIf="(coverage.planTypeCd == 'RIDER' || coverage.planTypeCd == 'BASEPLAN') && coverage 
              && coverage[UICoverageInsuredNodeName] && 
              coverage[UICoverageInsuredNodeName][insuredObj.guid] && coverage.sumInsuredAmt > 0" class="v-a-top">
                <td>
                  {{coverage.productCd | technicalTranslate: 'productId'}}
                  <nz-tag [nzColor]="'green'" style="margin-left: 10px;"> {{ (coverage.coverageType | technicalTranslate) || '-' }}</nz-tag>
                  <!-- [nzColor]="'#87d068'" -->
                </td>
                <td>{{coverage.sumInsuredAmt | CurrencyFormatter : (currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                <td>{{coverage.totalPremiumAmt | CurrencyFormatter : (currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                <td>
                  <ng-container
                    *ngIf="coverage && coverage[UICoverageInsuredNodeName] && coverage[UICoverageInsuredNodeName][insuredObj.guid]; else noCoverageInsuredFoundTemplate">
                    <nz-select nzShowSearch style="width: 100%"
                      [(ngModel)]="coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd"
                      (ngModelChange)="setSelectedCoverageDecision(coverage,coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd)">
                      <nz-option
                        *ngFor="let item of (lookup$['manualUwDecisionCd'] | async) as decisionCd; trackBy:item?.lookupKey"
                        [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                    </nz-select>
                  </ng-container>
                  <ng-template #noCoverageInsuredFoundTemplate>
                    <ng-container *ngIf="!environment.production">
                      Insured Not Found.
                    </ng-container>
                    <ng-container *ngIf="environment.production">
                      Coverage Specific Decision Not Allowed.
                    </ng-container>
                  </ng-template>
                </td>
                <td *ngIf="!revisedSumAssured && loadingPercent && loadingPercent[i] && loadingMethod[i]!='FLATEXTRA'">{{loadingPercent[i]}}%</td>
                <td *ngIf="!revisedSumAssured && loadingPercent && loadingPercent[i] && loadingMethod[i]=='FLATEXTRA'">{{loadingPercent[i] | CurrencyFormatter : (currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                <td *ngIf="(!revisedSumAssured && loadingPercent.length && !loadingPercent[i])">-</td>
                <td *ngIf="(!revisedSumAssured && !coverage.sumInsuredAmt && loadingPercent.length && !loadingPercent[i])">-</td>
                <td>
                  <!-- <pre>{{coverage.caseCovLoadingExclusions | json}}</pre> -->
                  <button *ngIf="coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd != 'REJECT'" nz-button nz-dropdown [nzDropdownMenu]="selActionMenu" nzType="dashed"><span>
                      {{ selectedAction[i] ? selectedAction[i] : 'Select Action' }}</span> <i nz-icon nzType="down"></i></button>
                    <nz-dropdown-menu #selActionMenu="nzDropdownMenu">
                    <ul nz-menu>
                      <nz-spin [nzSpinning]="isLoadingPopupData">
                        <ng-container
                          *ngIf="coverage[UICoverageInsuredNodeName][insuredObj.guid] && coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd == 'RATED'">
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Add Exclusions'"
                            (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 1, i); selectAction('Add Exclusions', i)">
                            <a>Add Exclusions</a>
                          </li>
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Rate Change'"
                            (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 2,i); selectAction('Rate Change',i)">
                            <a>Rate Change</a>
                          </li>
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Extra Premium Loading'"
                            (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 0,i); selectAction('Extra Premium Loading',i)">
                            <a>Extra Premium Loading</a>
                          </li>
                        </ng-container>
                        <ng-container
                          *ngIf="coverage[UICoverageInsuredNodeName][insuredObj.guid] && coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd == 'ACCEPTREVISED'">
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Add Exclusions'" 
                          (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 0,i); selectAction('Add Exclusions', i)">
                          <a>Add Exclusions</a>
                          </li>
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Change in Sum Assured'" 
                            (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 1,i); selectAction('Change in Sum Assured' ,i)">
                            <a>Change in Sum Assured</a>
                          </li>
                        </ng-container>

                        <ng-container *ngIf="coverage[UICoverageInsuredNodeName][insuredObj.guid] && coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd != 'RATED' && coverage[UICoverageInsuredNodeName][insuredObj.guid].uwDecisionCd != 'ACCEPTREVISED'">
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Add Exclusions'"
                            (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 0,i); selectAction('Add Exclusions' , i)">
                            <a>Add Exclusions</a>
                          </li>
                          <li nz-menu-item *ngIf="selectedAction[i] !== 'Rate Change'"
                            (click)="openAddMoreDataPopup(coverage, insuredObj.guid, coverage[UICoverageInsuredNodeName][insuredObj.guid], 1,i); selectAction('Rate Change' ,i)">
                            <a>Rate Change</a>
                          </li>
                        </ng-container>
                      </nz-spin>
                    </ul>
                  </nz-dropdown-menu>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>

        <!-- <pre>{{coverageList | json}}</pre> -->
      </div>
      <!-- <ng-container *ngIf="!environment.production">
      {{coverageList | json}}
    </ng-container> -->
    </ng-container>

    <ng-template #showNoInsuredSpecificCoverageMsg>
      <nz-alert class="m-b-20" nzType="info" nzMessage="No insured specific coverages are available for this insured."></nz-alert>
    </ng-template>



  </nz-tab>
</nz-tabset>

<nz-modal [(nzVisible)]="modExclusionsAndRateChange" nzTitle="Underwriting Actions"
  (nzOnCancel)="modExclusionsAndRateChange=false" (nzOnOk)="closeAddMoreDataPopup(ratedTypeCd, extraValue)" nzOkText="Save" nzWidth="80%">
  <ng-container *nzModalContent>
  <nz-skeleton [nzActive]="true" [nzLoading]="dataBindingInProgress"></nz-skeleton>
  <nz-tabset *ngIf="!dataBindingInProgress" [nzSelectedIndex]="popupDataPoints.tabIndex || 0">
    <nz-tab *ngIf="popupDataPoints && 
        popupDataPoints.coverageInsured && 
        popupDataPoints.coverageInsured.uwDecisionCd == 'RATED'" nzTitle="Extra Premium">
      <ng-container>

        <div *ngIf="showExtraHeadersInsideAccordion" class="heading-tab">
          <h3 class="heading">
            <i nz-icon nzType="file-unknown" class="m-r-5"></i> <span translate>Extra Premium</span></h3>
        </div>

        <div class="grid grid-gap-20 grid-4x m-t-20">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Rated Decision</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch [(ngModel)]="ratedTypeCd" (ngModelChange)="extracValuePrefix(ratedTypeCd)"
                style="width: 100%">
                <nz-option *ngFor="let item of (lookup$.loadingMethodCd | async) as decisionCd; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                <ng-container *ngIf="!!!decisionCd">
                  <nz-option [nzLabel]="'Flat Extra'" [nzValue]="'FLATEXTRA'"></nz-option>
                  <nz-option [nzLabel]="'Percent Extra'" [nzValue]="'PERCENTEXTRA'"></nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Extra Value</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-input-group *ngIf="ratedTypeCd == 'FLATEXTRA';else showPlaneValue">
                <input type="text" nz-input placeholder="Enter flat extra value" [(ngModel)]="extraValue"/>
              </nz-input-group>
              <ng-template #showPlaneValue>
                <nz-input-group [nzPrefix]="extraValuePrefix">
                  <input type="text" nz-input placeholder="Enter percent extra value" [(ngModel)]="extraValue"/>
                </nz-input-group>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

        </div>

      </ng-container>
    </nz-tab>
    <nz-tab *ngIf="popupDataPoints && popupDataPoints.coverageInsured" nzTitle="Exclusions">
      <ng-container>

        <div *ngIf="showExtraHeadersInsideAccordion" class="heading-tab">
          <h3 class="heading">
            <i nz-icon nzType="file-unknown" class="m-r-5"></i> <span translate>Exclusions</span></h3>
        </div>

        <exclusions-multi-add-panel *ngIf="popupDataPoints.coverage.caseCovLoadingExclusions" [IO]="IO"
          [inputDataForEdit]="popupDataPoints.coverage.caseCovLoadingExclusions"
          [(ngModel)]="popupDataPoints.coverage.caseCovLoadingExclusions">
        </exclusions-multi-add-panel>
        <exclusions-multi-add-panel *ngIf="popupDataPoints.coverage.policyCovLoadingExclusionList" [IO]="IO"
          [inputDataForEdit]="popupDataPoints.coverage.policyCovLoadingExclusionList"
          [(ngModel)]="popupDataPoints.coverage.policyCovLoadingExclusionList">
        </exclusions-multi-add-panel>

        <!-- <pre>{{exclusionList | json}}</pre> -->

      </ng-container>
    </nz-tab>
    <nz-tab *ngIf="popupDataPoints && popupDataPoints.coverage && 
    popupDataPoints.coverage.caseCoverageSchedules && 
    popupDataPoints.coverage.caseCoverageSchedules.length > 0 && popupDataPoints.coverageInsured.uwDecisionCd != 'ACCEPTREVISED'" nzTitle="Rate Change">
      <ng-container>

        <div *ngIf="showExtraHeadersInsideAccordion" class="heading-tab">
          <h3 class="heading">
            <i nz-icon nzType="file-unknown" class="m-r-5"></i> <span translate>Rate Change</span></h3>
        </div>

        <nz-tabset [nzTabPosition]="'left'">
          <nz-tab *ngFor="let item of (popupDataPoints.coverage.caseCoverageSchedules || 
              popupDataPoints.coverage.policyCoverageScheduleList)" nzTitle="Year {{item.policyYear}}">

            <div class="search-results m-t-20">
              <!-- *ngIf="clientList && clientList.length > 0" -->
              <nz-table *ngIf="item" [nzShowPagination]="false" #changeRateGrid [nzData]="[item]">
                <thead>
                  <tr>

                    <th>Coverage Name</th>
                    <th>Coverage Type</th>
                    <th>Plan Type</th>
                    <th>Rate</th>
                    <th>Revised Rate</th>
                    <th>Premium</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let data of changeRateGrid.data; let i=index">
                    <tr *ngIf="data">
                      <td>{{popupDataPoints.coverage.productCd | technicalTranslate}}</td>
                      <td>{{data.productTypeCd | technicalTranslate}}</td>
                      <td>{{popupDataPoints.coverage.planTypeCd | technicalTranslate}}</td>
                      <td>{{data.premiumRate}}</td>
                      <td>
                        <nz-form-item>
                          <nz-form-control>
                            <input type="text" nz-input placeholder="Rate" [(ngModel)]="data.newPremiumRate" />
                          </nz-form-control>
                        </nz-form-item>
                      </td>
                      <td>{{data.baseAnnualPremiumAmt | CurrencyFormatter : (currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>

                    </tr>
                  </ng-container>
                </tbody>
              </nz-table>
              <app-generic-zero-ui [list]="changeRateGrid" icon="file-search"></app-generic-zero-ui>
            </div>
          </nz-tab>
        </nz-tabset>`

      </ng-container>
    </nz-tab>
    <nz-tab *ngIf="popupDataPoints && popupDataPoints.coverage && popupDataPoints.coverageInsured.uwDecisionCd == 'ACCEPTREVISED'" nzTitle="Change in Sum Assured">
      <ng-container>

        <div *ngIf="showExtraHeadersInsideAccordion" class="heading-tab">
          <h3 class="heading">
            <i nz-icon nzType="file-unknown" class="m-r-5"></i> <span translate>Change in Sum Assured</span></h3>
        </div>

        <div class="grid grid-gap-20 grid-4x m-t-20">

          <nz-form-item>
            <nz-form-label [nzSpan]="24">Current Sum Assured</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-input-group>
                <input type="text" currencyMask [options]="currencyOptions" [readonly]="true" nz-input placeholder="Current sum assured" [(ngModel)]="popupDataPoints.coverage.sumInsuredAmt"/>
              </nz-input-group> 
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Revised Sum Assured</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-input-group>
                <input type="text" currencyMask [options]="currencyOptions" nz-input placeholder="Enter revised sum assured" [(ngModel)]="revisedSumAssured"/>
              </nz-input-group>     
            </nz-form-control>
          </nz-form-item>

        </div>

      </ng-container>
    </nz-tab>
  </nz-tabset>
</ng-container>
</nz-modal>